import { Col, Legend, Row } from '@/components/Layout'
import { TableColumn } from '@/endpoints/models'
import { PageType } from '@/enums'
import { useAppContext } from '@/hooks'

import { FieldSetGap } from '../FieldSet'
import { CustomAttributesSwitcher } from './CustomAttributesSwitcher'
import { CustomAttributesSwitcherWrap } from './styles'
import { CustomAttributesProps } from './types'

export const CustomAttributes = <T extends TableColumn>({
	customAttributes,
	item,
	$pageType,
	hideLabelAndBorder = false,
}: CustomAttributesProps<T>) => {
	const { t } = useAppContext()

	if (!customAttributes) return <></>

	const content = (
		<Row style={{ alignItems: 'flex-start' }}>
			{customAttributes.map((customAttribute) => (
				<Col
					key={customAttribute.id}
					size={
						$pageType === PageType.OVERVIEW_PAGE ? 'medium' : 'custom'
					}
					width="100%"
				>
					<CustomAttributesSwitcherWrap $pageType={$pageType}>
						<CustomAttributesSwitcher
							item={item}
							customAttribute={customAttribute}
							$pageType={$pageType}
						/>
					</CustomAttributesSwitcherWrap>
				</Col>
			))}
		</Row>
	)

	if (customAttributes.length === 0) return <></>

	if (hideLabelAndBorder) {
		return <>{content}</>
	}

	return (
		<FieldSetGap>
			<Legend>{t('CUSTOM_ATTRIBUTES')}</Legend>
			{content}
		</FieldSetGap>
	)
}
